import { Component, OnInit, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { ActivatedRoute, Router, NavigationEnd, Event as RouterEvent } from '@angular/router';
import { filter } from 'rxjs/operators';
import { UiStateService } from 'src/app/services/ui-state.service';
import { LoaderService } from '../../services/loader.service';
import { KycService } from '../../services/modal-kyc/kyc.service';
import { Observable } from 'rxjs';
import { MenuMovilComponent } from '../menu-movil/menu-movil.component';
import { MenuDesktopComponent } from '../menu-desktop/menu-desktop.component';
import { NavbarUserComponent } from '../navbar-user/navbar-user.component';
import { SpinnerComponent } from '../UI/spinner/spinner.component';

@Component({
  selector: 'app-main-container',
  templateUrl: './main-container.component.html',
  styleUrls: ['./main-container.component.css'],
  standalone: true,
  imports: [CommonModule, RouterOutlet, MenuMovilComponent, MenuDesktopComponent, NavbarUserComponent, SpinnerComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainContainerComponent implements OnInit, AfterViewInit {

  isLoading: boolean = true;
  loadingMessage: string = 'Cargando...';
  intialLoading: boolean = false;
  initialLoadingMessage: string = 'Cargando...';
  isInvestPage: boolean = false;
  isWhiteBackground: boolean = false;
  isMenuCollapsed: boolean = false;

  // 🎨 UI STATE - Para saber si menú está oculto
  public readonly isMenuDesktopCollapsed$: Observable<boolean>;

  constructor(
    private loaderService: LoaderService, 
    private kycService: KycService,
    private uiStateService: UiStateService,
    private crf: ChangeDetectorRef,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.isMenuDesktopCollapsed$ = this.uiStateService.isMenuDesktopCollapsed$;
  }

  ngOnInit(): void {
    // this.loaderService.initialLoadingStatus.subscribe((loading) => {
    //   this.intialLoading = loading?.isLoading || false;
    //   this.initialLoadingMessage = loading?.loadingMessage || '';
    // });

    this.loaderService.dataIsLoading.subscribe((loading) => {
      this.isLoading = loading?.isLoading || false;
      this.loadingMessage = loading?.loadingMessage || '';
      this.crf.markForCheck();
    });

    // Suscribirse al estado del menú para evitar ExpressionChangedAfterItHasBeenCheckedError
    this.isMenuDesktopCollapsed$.subscribe(collapsed => {
      setTimeout(() => {
        this.isMenuCollapsed = collapsed;
        this.crf.markForCheck();
      }, 0);
    });

    this.router.events
      .subscribe((event: RouterEvent) => {
        if (event instanceof NavigationEnd) {
          // Usar setTimeout para evitar el error ExpressionChangedAfterItHasBeenCheckedError
          setTimeout(() => {
            this.isWhiteBackground = event.url !== '/administracion';
            this.crf.markForCheck();
          }, 0);
        }
      });

    setTimeout(() => {
      this.kycService.openModalKyc();
    }, 1500);

    // Suscribirse a los cambios de ruta
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd)
      )
      .subscribe((event: NavigationEnd) => {
        const currentRoute = event.urlAfterRedirects;
        // Usar setTimeout para evitar el error ExpressionChangedAfterItHasBeenCheckedError
        setTimeout(() => {
          this.isInvestPage = currentRoute.startsWith('/oportunidad') && this.router.routerState.snapshot.root.queryParamMap.has('id');
          this.crf.markForCheck();
        }, 0);
      });
  }

  ngAfterViewInit(): void {
    // Forzar la detección de cambios después de que la vista se haya inicializado
    this.crf.detectChanges();
  }
}